import React from 'react';
import { MdCheckCircle, MdError, MdLink, MdMoodBad } from 'react-icons/md';

import { CircularProgress } from '@material-ui/core';

import NoPreview from '~/assets/paper.svg';
import { useFiles, IFile } from '~/hooks/files';

import {
  Container,
  DeleteFileButton,
  FileInfo,
  Preview,
  UrlButton,
} from './styles';

interface Props {
  files: IFile[];
  canDelete?: boolean;
}

const FileList: React.FC<Props> = ({ files, canDelete = true }) => {
  const { deletingFile, handleDelete, handleDownloadFile } = useFiles();

  if (!files.length)
    return (
      <span>
        <MdMoodBad
          style={{ marginLeft: '45%', marginTop: 10 }}
          size={24}
          color="#d5d2d2"
        />
      </span>
    );

  return (
    <Container>
      {files.map((uploadedFile: IFile) => (
        <li key={uploadedFile.key}>
          <FileInfo>
            <Preview
              src={
                uploadedFile.file?.type.match('image/*')
                  ? uploadedFile.preview
                  : NoPreview
              }
            />
            <div>
              <strong>{uploadedFile.name}</strong>
              <span>
                {uploadedFile.readableSize} {uploadedFile.id}{' '}
                {!!uploadedFile.url && canDelete && (
                  <DeleteFileButton
                    type="button"
                    disabled={deletingFile === uploadedFile.key}
                    onClick={() => handleDelete([uploadedFile.key])}
                  >
                    {deletingFile === uploadedFile.key
                      ? 'Excluindo...'
                      : 'Excluir'}
                  </DeleteFileButton>
                )}
                {uploadedFile.error && canDelete && (
                  <DeleteFileButton
                    type="button"
                    disabled={deletingFile === uploadedFile.key}
                    onClick={() => handleDelete([uploadedFile.key])}
                  >
                    {deletingFile === uploadedFile.key
                      ? 'Excluindo...'
                      : 'Excluir'}
                  </DeleteFileButton>
                )}
              </span>
            </div>
          </FileInfo>

          <div>
            {!uploadedFile.uploaded && !uploadedFile.error && (
              <CircularProgress
                variant="static"
                value={uploadedFile.progress || 0}
                size={24}
              />
            )}

            {uploadedFile.url && (
              <UrlButton
                type="button"
                onClick={() => handleDownloadFile(uploadedFile.key)}
              >
                <MdLink style={{ marginRight: 8 }} size={24} color="#222" />
              </UrlButton>
            )}

            {uploadedFile.uploaded && (
              <MdCheckCircle size={24} color="#78e5d5" />
            )}
            {uploadedFile.error && (
              <div
                style={{
                  display: 'flex',
                }}
              >
                <p
                  style={{
                    marginRight: '10px',
                    marginTop: '2px',
                    color: '#e57878',
                  }}
                >
                  Erro ao fazer upload do arquivo
                </p>
                <MdError size={24} color="#e57878" />
              </div>
            )}
          </div>
        </li>
      ))}
    </Container>
  );
};

export default FileList;
